import React, { useContext } from 'react';
import ReactDOM from 'react-dom/client';
import { AuthenticatedApp } from './views/AuthenticatedApp';
import { UnauthenticatedApp } from './views/UnauthenticatedApp';
import { UserContext, UserProvider } from './providers/UserProvider';
import { GlobalStyle } from './assets/styles/GlobalStyle';
import { ThemeProvider } from 'styled-components';
import { GlobalTheme } from './assets/styles/GlobalTheme';
import { ErrorsProvider } from 'providers/ErrorsProvider';
import { AuthenticatingApp } from 'views/AuthenticatingApp';
import "@fontsource/material-symbols-outlined";


const App = () => {
		
	const { user, isAuthenticating } = useContext(UserContext);

	if(user) return (<AuthenticatedApp/>);
	else if(isAuthenticating) return <AuthenticatingApp/>
	else return (<UnauthenticatedApp/>)
}

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
	<React.StrictMode>
		<ThemeProvider theme={GlobalTheme}>
			<ErrorsProvider>
				<UserProvider>
					<GlobalStyle/>
					<App/>
				</UserProvider>
			</ErrorsProvider>
		</ThemeProvider>
	</React.StrictMode>
);

